import React, { ComponentProps, memo } from 'react'

import { useTranslation } from '../services'

import { DefaultDialog } from './DefaultDialog'

export const DefaultCancelChangesDialog = memo(
  ({
    ...rest
  }: Omit<
    ComponentProps<typeof DefaultDialog>,
    'title' | 'text' | 'confirmButtonLabel' | 'cancelButtonLabel'
  >) => {
    const { t } = useTranslation()

    return (
      <DefaultDialog
        {...{
          title: t('defaultCancelChangesDialog.title'),
          text: t('defaultCancelChangesDialog.text'),
          confirmButtonLabel: t(
            'defaultCancelChangesDialog.confirmButtonLabel',
          ),
          cancelButtonLabel: t('defaultCancelChangesDialog.cancelButtonLabel'),
          ...rest,
        }}
      />
    )
  },
)
